export const bookmakersDropdownList = `bookmakers(filters: {search: $search, hide_assigned:true}) {
    id,
    name,
    key : id,
    value : id,
    text : name
}`;


export const bookmakersListQuery = `
query DropdownListBookmaker($search: String!) {
    ${bookmakersDropdownList}
}`;
